import { render, staticRenderFns } from "./ListUsers.vue?vue&type=template&id=2e2a4e78&"
import script from "./ListUsers.vue?vue&type=script&lang=js&"
export * from "./ListUsers.vue?vue&type=script&lang=js&"
import style0 from "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./ListUsers.vue?vue&type=style&index=1&id=2e2a4e78&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports